import { render, staticRenderFns } from "./CompanyDetailDialog.vue?vue&type=template&id=94a5b44a&scoped=true"
import script from "./CompanyDetailDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailDialog.vue?vue&type=style&index=0&id=94a5b44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5b44a",
  null
  
)

export default component.exports